import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryTypeSelect`

export default defineMessages({
  allBudgets: {
    id: `${scope}.allBudgetCategories`,
    defaultMessage: 'All budgets',
  },
  allBudgetCategories: {
    id: `${scope}.allBudgetCategories`,
    defaultMessage: 'All budget categories',
  },
  onlySourceOfTruthBudgetCategories: {
    id: `${scope}.onlySourceOfTruthBudgetCategories`,
    defaultMessage: 'Only source of truth',
  },
  excludeSourceOfTruthBudgetCategories: {
    id: `${scope}.excludeSourceOfTruthBudgetCategories`,
    defaultMessage: 'Exclude source of truth',
  },
  budgetCateogryTypeSelectPlaceholder: {
    id: `${scope}.budgetCateogryTypeSelectPlaceholder`,
    defaultMessage: 'Select an option',
  },
})
